import {
  SET_PROGRAM_MODULES_TREE,
  SET_PROGRAM_MODULES_LOADING,
  SET_PROGRAM_MODULES_CID,
} from '../actions/types';

const initialState = {
  tree: [],
  cid: null,
  loading: false,
};

export default function programModules(state = initialState, action) {
  switch (action.type) {
    case SET_PROGRAM_MODULES_TREE:
      return {
        ...state,
        tree: action.payload,
      };
    case SET_PROGRAM_MODULES_CID:
      return {
        ...state,
        cid: action.payload,
      };
    case SET_PROGRAM_MODULES_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
}
